import PropTypes from 'prop-types';
import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import auth from '../../auth';
import DoneIcon from 'material-ui/svg-icons/action/done';
import DeleteIcon from 'material-ui/svg-icons/action/delete';

const mandatoryFields = [
    {
        key: 'teamId',
        dataType: 'ENET_TEAM_ID',
        desc: 'Default team',
        required: true,
    },
    {
        key: 'tournamentId',
        dataType: 'ENET_TOURNAMENT_ID',
        desc: 'Default tournament id',
        required: true,
    },
    {
        key: 'lang',
        dataType: 'LANGUAGE',
        desc: 'Default language',
        required: true,
    },
    {
        key: 'GA',
        dataType: 'STRING',
        desc: 'Google Anatytics account',
        required: true,
    },
];

class AccountDefaults extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            fields: mandatoryFields,
            isLoading: true,
            saveSuccess: false,
            saveError: false,
            errors: {},
        };

        this.loadData();
    }

    loadData = () => {
        const token = auth.getAccessToken();
        const { _id: userId } = this.context.user;
        return fetch(`/api/users/${userId}?access_token=${token}`)
            .then(response => response.json())
            .then(user => {
                var combinedFields = _.unionWith(user.defaultProps, mandatoryFields, (a, b) => {
                    return a.key === b.key;
                });

                this.setState({
                    fields: combinedFields,
                    isLoading: false,
                });
            });
    };

    static contextTypes = {
        user: PropTypes.object.isRequired,
    };

    addField = () => {
        var fields = this.state.fields;
        fields.push({
            key: '',
            value: '',
            dataType: '',
            desc: '',
            isNew: true,
        });

        this.setState({ fields });
    };

    saveFields = () => {
        var fields = this.state.fields;
        var body = {
            defaultProps: fields,
        };

        var invalidFields = fields.filter(f => !f.key);

        if (invalidFields.length) {
            invalidFields.forEach(f => {
                f.keyError = ' ';
            });
            this.setState({ fields });
            return;
        }

        this.setState({ isSaving: true, saveSuccess: false });
        const token = auth.getAccessToken();
        const { _id: userId } = this.context.user;
        return fetch(`/api/users/${userId}`, {
            method: 'PUT',

            headers: {
                'Content-Type': 'application/json',
                authorization: token,
            },
            body: JSON.stringify(body),
        })
            .then(response => {
                if (response.ok) {
                    return response.json().then(user => {
                        this.setState({ isSaving: false, saveSuccess: true, fields: user.defaultProps });
                        auth.saveUser(user);
                    });
                } else {
                    this.setState({ saveError: true, isSaving: false });
                }
            })
            .catch(err => {
                this.setState({ saveError: true, isSaving: false });
                console.error(err);
            });
    };

    removeProp(index) {
        var fields = this.state.fields;

        fields.splice(index, 1);

        this.setState({ fields });
    }

    setFieldValue(field, e) {
        field.value = e.target.value;

        this.setState({ fields: this.state.fields });
    }

    setFieldKey(field, e) {
        field.key = e.target.value;

        this.setState({ fields: this.state.fields });
    }

    renderPropertyRow = (field, index) => {
        return (
            <rmd.TableRow key={index}>
                <rmd.TableRowColumn>
                    {!field.required ? (
                        <rmd.TextField
                            value={field.key || ''}
                            onChange={this.setFieldKey.bind(this, field)}
                            errorText={field.keyError}
                            name="New key"
                            hintText="Enter key"
                        />
                    ) : (
                        field.key
                    )}
                </rmd.TableRowColumn>
                <rmd.TableRowColumn>
                    <rmd.TextField
                        value={field.value || ''}
                        onChange={this.setFieldValue.bind(this, field)}
                        errorText={this.state.errors[field.key]}
                        name={field.key}
                        hintText="Enter value"
                    />
                </rmd.TableRowColumn>
                <rmd.TableRowColumn>{field.dataType}</rmd.TableRowColumn>
                <rmd.TableRowColumn>{field.desc}</rmd.TableRowColumn>
                <rmd.TableRowColumn style={{ width: 90 }}>
                    {!field.required ? (
                        <rmd.IconButton onClick={this.removeProp.bind(this, index)}>
                            <DeleteIcon />
                        </rmd.IconButton>
                    ) : (
                        ''
                    )}
                </rmd.TableRowColumn>
            </rmd.TableRow>
        );
    };

    renderFooter() {
        return (
            <rmd.CardActions className="actions">
                <rmd.RaisedButton onClick={this.addField} style={{ marginRight: 30 }}>
                    Add field
                </rmd.RaisedButton>
                <rmd.RaisedButton backgroundColor="#a4c639" style={{ marginRight: 45 }} onClick={this.saveFields}>
                    Save all
                </rmd.RaisedButton>
                {this.state.isSaving ? (
                    <rmd.CircularProgress size={0.4} style={{ position: 'absolute', right: 0, top: 0 }} />
                ) : (
                    ''
                )}
                {this.state.saveSuccess ? <DoneIcon style={{ position: 'absolute', right: 5, bottom: 15 }} /> : ''}
                <rmd.Snackbar
                    open={this.state.saveSuccess}
                    message="Properties have been successfully saved"
                    autoHideDuration={4000}
                />
                <rmd.Snackbar
                    open={this.state.saveError}
                    className="snackbar-error"
                    message="Server error. Records are not saved "
                    action="close"
                    onActionTouchTap={() => this.setState({ saveError: false })}
                />
            </rmd.CardActions>
        );
    }

    render() {
        return (
            <div className="row">
                <div className="col-12">
                    <div className="account-defaults">
                        <rmd.Table selectable={false}>
                            <rmd.TableHeader displaySelectAll={false}>
                                <rmd.TableRow>
                                    <rmd.TableHeaderColumn>Key</rmd.TableHeaderColumn>
                                    <rmd.TableHeaderColumn>Value</rmd.TableHeaderColumn>
                                    <rmd.TableHeaderColumn>Data Type</rmd.TableHeaderColumn>
                                    <rmd.TableHeaderColumn>Description</rmd.TableHeaderColumn>
                                    <rmd.TableHeaderColumn style={{ width: 90 }} />
                                </rmd.TableRow>
                            </rmd.TableHeader>
                            <rmd.TableBody displayRowCheckbox={false} showRowHover>
                                {this.state.fields.map(this.renderPropertyRow)}
                            </rmd.TableBody>
                        </rmd.Table>

                        {this.renderFooter()}
                    </div>
                </div>
            </div>
        );
    }
}

export default AccountDefaults;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/account/AccountDefaults.js
 **/